import fetch from '@/utils/fetch';
import { message } from 'antd';
import { getUrlParam } from '@/utils/url';

const model = {
  state: {
    businessDistrictId: '',
    businessDistrictName: '',
    updateRuleListFlag: 0,
    updateCalendarListFlag: 0,
    updateRuleDetailFlag: 0,
    updateMerchantsFlag: 0,
    smallAmountVisible: false,
    activeTabKey: 'list',
    actionCbd: {},
    mealTimeOption: [],
    ruleId: null,
    cbdId: null,
    companyNameList: [],
    provinceCityTree: [],
    provinceList: [],
    highLightShopList: [],
    highLightIndex: null,
    activeScheduleKey: '1',
    mealTimeItem: {},
    shareCompanyList: [],
    companyItem: {
      companyId: 0,
      companyName: '',
    },
    saasAgentId: 0,
  },
  reducers: {
    setState(state, partialState) {
      return { ...state, ...partialState };
    },
  },
  // eslint-disable-next-line no-unused-vars
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  actions: ({ dispatch: { OperationBussiness }, getState }) => ({
    setActiveScheduleKey(activeScheduleKey) {
      OperationBussiness.setState({
        activeScheduleKey,
      });
    },
    setHighLightShopList(highLightShopList) {
      OperationBussiness.setState({
        highLightShopList,
      });
    },
    setHighLightIndex(highLightIndex) {
      OperationBussiness.setState({
        highLightIndex,
      });
    },
    clearHighLight() {
      OperationBussiness.setState({
        highLightIndex: null,
        highLightShopList: [],
      });
    },
    setUpdateRuleDetailFlag(newV) {
      OperationBussiness.setState({
        updateRuleDetailFlag: newV,
      });
    },
    setUpdateRuleListFlag(newV) {
      OperationBussiness.setState({
        updateRuleListFlag: newV,
      });
    },
    setUpdateCalendarListFlag(newV) {
      OperationBussiness.setState({
        updateCalendarListFlag: newV,
      });
    },
    setBusinessDistrictId(id) {
      OperationBussiness.setState({
        businessDistrictId: id,
      });
    },
    setBusinessDistrictName(name) {
      OperationBussiness.setState({
        businessDistrictName: name,
      });
    },
    setUpdateMerchantsFlag(newV) {
      OperationBussiness.setState({
        updateMerchantsFlag: newV,
      });
    },
    setSmallAmountVisible(visible) {
      OperationBussiness.setState({
        smallAmountVisible: visible,
      });
    },
    setActiveTabKey(key) {
      OperationBussiness.setState({
        activeTabKey: key,
      });
    },
    setActionCbd(cbd) {
      OperationBussiness.setState({
        actionCbd: cbd,
      });
    },
    setMealTimeOption(mealTimeOption) {
      OperationBussiness.setState({
        mealTimeOption,
      });
    },
    setRuleId(ruleId) {
      OperationBussiness.setState({
        ruleId,
      });
    },
    setCbdId(cbdId) {
      OperationBussiness.setState({
        cbdId,
      });
    },
    setMealTimeItem(mealTimeItem) {
      OperationBussiness.setState({
        mealTimeItem,
      });
      OperationBussiness.getShareCompanyList(mealTimeItem.value);
    },
    setCompanyItem(companyItem) {
      OperationBussiness.setState({
        companyItem,
      });
    },

    async searchCompany(params) {
      const data = await fetch('/saasmerchant/fsarea/company/queryEsInfoByName', {
        params: {
          ...params,
        },
      });
      if (data) {
        OperationBussiness.setState({ companyNameList: data });
      }
      return data;
    },
    cleanCompanyNameList() {
      OperationBussiness.setState({ companyNameList: [] });
    },
    async getCompanyList(cbdId) {
      const data = await fetch('/saasmerchant/fsarea/rule/companyList', {
        params: {
          cbdId,
        },
      });
      return data;
    },
    // 商圈展示堂食入口
    async setBusinessCanteen(params) {
      const data = await fetch('/saasmerchant/fsarea/businessDistrict/setDineEntrance', {
        type: 'POST',
        useJson: true,
        params: {
          ...params,
        },
      });
      if (data) {
        message.success('设置成功');
      }
      return data;
    },
    // 获取展示堂食入口信息
    async getBusinessCanteen(businessDistrictId) {
      const data = await fetch('/saasmerchant/fsarea/businessDistrict/getDineEntrance', {
        params: {
          businessDistrictId,
        },
      });
      return data;
    },
    // 获取省市信息
    async getProvinceCity() {
      const data = await fetch('/saasmerchant/fsarea/businessDistrict/getAllNames');
      OperationBussiness.setState({
        provinceCityTree: data.map((province) => ({
          label: province.provinceName,
          value: province.provinceCode,
          children: province.citys.map((city) => {
            return {
              label: city.cityName,
              value: city.cityCode,
            };
          }),
        })),
      });
      return data;
    },
    async getProvinceList() {
      const data = await fetch('/saasmerchant/fsarea/businessDistrict/getProvinceList');
      OperationBussiness.setState({
        provinceList: data || [],
      });
      return data;
    },
    async getCityListByPro(provinceCode) {
      const data = await fetch('/saasmerchant/fsarea/businessDistrict/getCityListByPro', {
        params: { provinceCode },
        type: 'GET',
      });
      return data;
    },
    // 查看共享排班企业
    async getShareCompanyList() {
      const params = getState().OperationBussiness;
      if (params.mealTimeItem.value) {
        const data = await fetch('/saasmerchant/fsarea/rule/share/company/list', {
          params: {
            mealTimeId: getState().OperationBussiness.mealTimeItem.value,
          },
          type: 'GET',
        });
        OperationBussiness.setState({ shareCompanyList: data });
        return data;
      }
    },
    async getShareMealList(pageParams, history) {
      const cbdId = getUrlParam('id');
      const data = await fetch('/saasmerchant/fsarea/rule/share/meal/list', {
        params: {
          cbdId: getState().OperationBussiness.cbdId || cbdId,
          mealTimeId: getState().OperationBussiness.mealTimeItem.value,
          companyId: getState().OperationBussiness.companyItem.companyId || '0',
          ...pageParams,
        },
        type: 'POST',
        useJson: true,
      });
      return data?.list;
    },
    async addShareCompanyList(bindMealTimeId, history) {
      if (bindMealTimeId?.length) {
        const cbdId = getUrlParam('id');
        const data = await fetch('/saasmerchant/fsarea/rule/add/share', {
          params: {
            cbdId: getState().OperationBussiness.cbdId || cbdId,
            mealTimeId: getState().OperationBussiness.mealTimeItem.value,
            companyId: getState().OperationBussiness.companyItem?.companyId,
            bindMealTimeId: bindMealTimeId[0],
          },
          type: 'POST',
          useJson: true,
        });
        return data;
      }
    },

    async businessDistrictDetail(params) {
      const data = await fetch('/saasmerchant/fsarea/businessDistrict/businessDistrictDetail', {
        params,
        useJson: true,
      });
      OperationBussiness.setState({ saasAgentId: data.saasAgentId });
      return data;
    },
  }),
};

export default model;
